"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasDomElement = exports.matchPaths = exports.testPath = exports.not = void 0;
function not(condition) {
    return () => !condition();
}
exports.not = not;
function testPath(pattern) {
    return () => pattern.test(window.location.pathname);
}
exports.testPath = testPath;
function matchPaths(...args) {
    return () => args.some(arg => arg === window.location.pathname);
}
exports.matchPaths = matchPaths;
function hasDomElement(selector) {
    return () => document.querySelector(selector) !== null;
}
exports.hasDomElement = hasDomElement;
